import { FC } from 'react';

import { OptionType } from '@zazume/zzm-base';
import { LanguageVO, Nationalities } from '@zazume/zzm-utils';

import { Select } from '#/components/forms/select/SelectBase';
import { useI18n } from '#/hooks/useI18n';

interface Props {
  name: string;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
}

const getNationalityOptions = (lang: LanguageVO): OptionType[] => {
  return Object.entries(Nationalities.getAll(lang)).map(([code, value]) => ({
    name: value,
    value: code
  }));
};

/**
 * @deprecated use ZZMForm.NationalitySelect instead
 * @param name
 * @param label
 * @param placeholder
 * @param disabled
 */
export const NationalitySelect: FC<Props> = ({ name, label, placeholder, disabled }) => {
  const { t, languageVO } = useI18n();
  const nationalityOptions = getNationalityOptions(languageVO);

  return (
    <Select
      name={name}
      label={label || t('general.nationality')}
      placeholder={placeholder || t('general.forms.placeholders.nationality')}
      options={nationalityOptions}
      disabled={disabled}
      withSearch
    />
  );
};
